import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Popconfirm } from 'antd';
import deleteIcon from '../../../../../../img/client/icons/delete.svg';

/**
 * DeleteRowButton Component
 * Delete button with confirmation popover for product rows
 *
 * @param {Object} props
 * @param {Function} props.onDelete - Callback when delete is confirmed
 * @param {string} props.tooltip - Tooltip text
 * @param {string} props.confirmTitle - Popconfirm title
 * @param {string} props.confirmDescription - Popconfirm description
 * @param {string} props.confirmOk - Confirm button text
 * @param {string} props.confirmCancel - Cancel button text
 * @param {number} [props.size=20] - Icon size
 * @param {string} [props.variant='circle'] - Button variant: 'circle' or 'square'
 */
const DeleteRowButton = ({
  onDelete,
  tooltip,
  confirmTitle,
  confirmDescription,
  confirmOk,
  confirmCancel,
  size = 20,
  variant = 'circle',
}) => {
  const buttonClass =
    variant === 'circle'
      ? 'flex w-8 h-8 items-center justify-center rounded-full border border-[#7CB305] cursor-pointer'
      : 'flex w-8 h-8 items-center justify-center rounded-lg border border-[#7CB305] cursor-pointer';

  return (
    <Popconfirm
      title={confirmTitle}
      description={confirmDescription}
      onConfirm={onDelete}
      okText={confirmOk}
      cancelText={confirmCancel}
      okButtonProps={{ danger: true }}
    >
      <Tooltip title={tooltip}>
        <button className={buttonClass}>
          <img
            src={deleteIcon}
            alt="Delete"
            width={size}
            height={size}
            className="pointer-events-none"
          />
        </button>
      </Tooltip>
    </Popconfirm>
  );
};

DeleteRowButton.propTypes = {
  onDelete: PropTypes.func.isRequired,
  tooltip: PropTypes.string.isRequired,
  confirmTitle: PropTypes.string.isRequired,
  confirmDescription: PropTypes.string.isRequired,
  confirmOk: PropTypes.string.isRequired,
  confirmCancel: PropTypes.string.isRequired,
  size: PropTypes.number,
  variant: PropTypes.oneOf(['circle', 'square']),
};

export default React.memo(DeleteRowButton);
